import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  ExclamationTriangleIcon,
  EyeIcon
} from '@heroicons/react/24/outline';
import { 
  SurveillanceTabType, 
  selectCurrentTab, 
  setCurrentTab,
  setCurrentPage,
  SurveillanceTabValues
} from '../../store/slices/surveillanceSlice';

const SurveillanceTabs: React.FC = () => {
  const dispatch = useDispatch();
  const currentTab = useSelector(selectCurrentTab);

  const handleTabChange = (tab: SurveillanceTabType) => {
    if (tab !== currentTab) {
      dispatch(setCurrentTab(tab));
      dispatch(setCurrentPage(1)); // Reset to page 1 when changing tab
    }
  };

  const tabs = [
    {
      id: SurveillanceTabValues.BODACC_ANOMALIES,
      name: "Anomalies BODACC",
      icon: ExclamationTriangleIcon,
      description: "Publications BODACC concernant vos adhérents"
    },
    {
      id: SurveillanceTabValues.SIRET_SURVEILLANCE,
      name: "Surveillance SIRET",
      icon: EyeIcon,
      description: "Suivi des ouvertures et fermetures d'établissements"
    }
  ];

  return (
    <div className="mb-6">
      <div className="sm:hidden">
        <label htmlFor="surveillance-tabs" className="sr-only">
          Sélectionner un onglet de surveillance
        </label>
        <select
          id="surveillance-tabs"
          name="surveillance-tabs"
          className="block w-full rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500"
          defaultValue={currentTab}
          onChange={(e) => handleTabChange(e.target.value as SurveillanceTabType)}
        >
          {tabs.map((tab) => (
            <option key={tab.id} value={tab.id}>
              {tab.name}
            </option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {tabs.map((tab) => {
              const isActive = tab.id === currentTab;
              const Icon = tab.icon;
              
              return (
                <button
                  key={tab.id}
                  onClick={() => handleTabChange(tab.id)}
                  className={`
                    flex items-center whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                    ${isActive
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }
                  `}
                  aria-current={isActive ? 'page' : undefined}
                >
                  <Icon 
                    className={`-ml-0.5 mr-2 h-5 w-5 ${isActive ? 'text-blue-500' : 'text-gray-400'}`} 
                    aria-hidden="true" 
                  />
                  <span>{tab.name}</span>
                </button>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default SurveillanceTabs; 